import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import { dbFB, auth, storage, functions } from "./components/firebase";
import axios from "axios";
import { store } from "./store/store";
import VueRouter from "vue-router";
import { routes } from "./router/routes";
import Paintable from "./plugins/Paintable";
import validationMessagesEs from "vee-validate/dist/locale/es";
import VeeValidate from "vee-validate";
Vue.use(VeeValidate, {
  // i18nRootKey: 'validations', // customize the root path for validation messages.
  locale: "es",
  dictionary: {
    es: validationMessagesEs
  }
});

Vue.prototype.$dbFB = dbFB;
Vue.prototype.$auth = auth;
Vue.prototype.$storage = storage;
Vue.prototype.$functions = functions;
Vue.http = Vue.prototype.$http = axios;

Vue.use(VueRouter);
Vue.use(Paintable);

const router = new VueRouter({
  routes: routes,
  mode: "history",
  base: "/"
});

function userToken() {
  if (localStorage._GA_es) {
    // Desencriptar
    const token = localStorage._GA_es;
    const data = JSON.parse(window.atob(token));
    return data.level ? data.level : 0;
  }
  return 0;
}

router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next("/sign-in");
  } else if (requiresAuth && currentUser) {
    const level = userToken(); //store.getters.getLevel;
    const requiredLevel = to.matched.some(record => record.meta.requiredLevel);
    const levelRequerido = requiredLevel ? to.meta.requiredLevel : 0;
    // eslint-disable-next-line
    // console.log("to", to);
    // console.log(`Level = ${level} / ${levelRequerido}`)
    if (to.fullPath.includes("user") && level < 5) {
      next("/usuario");
    }
    if (level < levelRequerido) {
      next("/sign-in");
    } else {
      next();
    }
  } else {
    next();
  }
});

function saveToken(level) {
  const tkn = { level: level };
  const enc = window.btoa(JSON.stringify(tkn));
  localStorage._GA_es = enc;
}

Vue.config.productionTip = process.env.NODE_ENV === "production";
// Vue.config.silent = true
/* // eslint-disable-next-line
console.log(Vue.config.productionTip) */

auth.onAuthStateChanged(function() {
  /* router.beforeEach((to, from, next) => {
    const level = store.getters.getLevel;
    const requiredLevel = to.matched.some(record => record.meta.requiredLevel);
    const levelRequerido = requiredLevel ? to.meta.requiredLevel : 0
    // eslint-disable-next-line
    // console.log(`to = ${to.path}, from = ${from.path}, Level = ${level} / ${levelRequerido}`)
    // console.log(JSON.stringify(to))
    if (requiredLevel && level < levelRequerido) {
      next('/sign-in');
    } else if (requiredLevel && level >= levelRequerido) {
      next();
    } else {
      next();
    }
  }); */

  if (auth.currentUser) {
    const userLoged = auth.currentUser.uid;
    dbFB
      .ref(`users`)
      .child(userLoged)
      .child("admin")
      .child("level")
      .once("value")
      .then(snapshot => {
        if (snapshot.val() !== null) {
          saveToken(snapshot.val());
        }
      })
      .catch(err => {
        // eslint-disable-next-line
        console.log(err);
        saveToken(1);
      });
  } else {
    delete localStorage._GA_es;
  }

  new Vue({
    store: store,
    router: router,
    data: {},
    watch: {
      level(newValue) {
        if (newValue > 5) {
          // this.$route.router.go('/dashboard');
          this.$router.replace("/dashboard");
        }
      }
      /* configApp(newConfig) {
        if (newConfig) {
          // eslint-disable-next-line
          // console.log(newConfig.tablas.respuestasSistema.noAuth)
          const tabla = newConfig.tablas.respuestasSistema.noAuth
          this.$store.dispatch('setRespuestaSistema', tabla)
        }
      } */
    },
    created() {
      this.$store.dispatch("setConfigApp");

      // this.$store.dispatch('setRespuestaSistema')
    },
    computed: {
      configApp() {
        return this.$store.getters.getConfigApp;
      },
      level() {
        return this.$store.state.level;
      }
    },
    render: h => h(App)
  }).$mount("#app");
});
